import { format } from 'date-fns';

const generateLayerString = ({ meparCode, date }) => {
    const layerStringCode = `${meparCode}`;
    const layerStringDate = `${format(date, 'yyyy-MM-dd')}`;

    return {
        layerStringCode,
        layerStringDate,
    };
};

export default generateLayerString;
